import { useRef } from "react";
import { useReactToPrint } from "react-to-print";
import { Media, Modal, ModalBody, ModalHeader } from "reactstrap";
import { Btn, H3, H6, Image, P } from "../../../../../../AbstractElements";
import { PrintModalProps } from "../../../../../../Types/ContactType";
import { dynamicImage } from "../../../../../../Utils";
import { Cancel, EmailAddress, General, Print, PrintPreview } from "../../../../../../Utils/Constants";

export default function PrintModal({ printModal, selectedUser, toggleCallback }: PrintModalProps) {
  const contentRef = useRef<HTMLDivElement>(null);
  const handlePrint = useReactToPrint({ contentRef });
  const printModalToggle = () => {
    toggleCallback(false);
  };
  return (
    <Modal className="modal-bookmark" isOpen={printModal} toggle={printModalToggle}>
      <ModalHeader toggle={printModalToggle}>{PrintPreview}</ModalHeader>
      <ModalBody className="list-persons">
        <div className="profile-mail pt-0" ref={contentRef}>
          <Media>
            <Image className="img-100 img-fluid m-r-20 rounded-circle" src={dynamicImage(`user/user.png`)} alt="" />
            <Media body className="mt-0">
              <H3>
                <span>{selectedUser.name}</span>
                <span>{selectedUser.surname}</span>
              </H3>
              <P>
                {selectedUser.name}
                {"@gmail.com"}
              </P>
            </Media>
          </Media>
          <div className="email-general">
            <H6>{General}</H6>
            <P>
              {EmailAddress} :
              <span className="font-primary" id="mailadd">
                {selectedUser.surname}
                {"@gmail.com"}
              </span>
            </P>
          </div>
        </div>
        <Btn color="secondary" className="me-1" onClick={handlePrint}>
          {Print}
        </Btn>
        <Btn color="primary" onClick={printModalToggle}>
          {Cancel}
        </Btn>
      </ModalBody>
    </Modal>
  );
}
